let keyEventHandler = function(event) {

    let isAllowed = false; 

    let charAlphabet = [
        'a','b','c','ç','d','e','f','g','ğ','h','ı','i','j','k','l','m','n','o','ö','p','q','r','s','ş','t','u','ü','v','w','x','y','z',
        'A','B','C','Ç','D','E','F','G','Ğ','H','I','İ','J','K','L','M','N','O','Ö','P','Q','R','S','Ş','T','U','Ü','V','W','X','Y','Z',
        '0','1','2','3','4','5','6','7','8','9',
        ' ','_','-','*','\\','/',',',';',':','.','&','?','(',')','{','}','+','%'
    ];


    let key = event.key;
    let code = event.code;

    let inAlphabet = charAlphabet.indexOf(key) !== -1;

    let allowedKeys = [
        'ArrowLeft', 'ArrowDown', 'ArrowUp', 'ArrowRight',
        'Enter', 'Backspace', 'Delete', 'Shift', 'Tab', 'Space', 'Meta', 'MetaLeft', 'MetaRight', 'Control'
    ];

    if (allowedKeys.indexOf(code) !== -1 || inAlphabet) {
        isAllowed = true;
    }


    return {
        key: key,
        code: code,
        isAllowed: isAllowed,
        inAlphabet: inAlphabet,
    };

}

export default keyEventHandler